import React from 'react';

export const FilterComponent: { Component: React.FC<{ domain }> }[] = [];
